/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { api_createDropdownItemRequest } from '../models/api_createDropdownItemRequest';
import type { api_updateDropdownItemRequest } from '../models/api_updateDropdownItemRequest';
import type { db_DropdownDegree } from '../models/db_DropdownDegree';
import type { db_ListDegreesSearchRow } from '../models/db_ListDegreesSearchRow';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class Degrees {
    /**
     * Get a list of degrees
     * @returns db_DropdownDegree OK
     * @throws ApiError
     */
    public static listDegrees(): CancelablePromise<Array<db_DropdownDegree>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/degrees',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Create a new degree
     * @param body Degree details
     * @returns db_DropdownDegree Created
     * @throws ApiError
     */
    public static createDegree(
        body: api_createDropdownItemRequest,
    ): CancelablePromise<db_DropdownDegree> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/degrees',
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get a list of degrees for search
     * @param pageId Page ID
     * @param pageSize Page size
     * @param orderBy Order by
     * @param filters Filters
     * @param search Search string
     * @returns db_ListDegreesSearchRow OK
     * @throws ApiError
     */
    public static listDegreesSearch(
        pageId: number,
        pageSize: number,
        orderBy?: string,
        filters?: string,
        search?: string,
    ): CancelablePromise<Array<db_ListDegreesSearchRow>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/degrees-search',
            query: {
                'page_id': pageId,
                'page_size': pageSize,
                'order_by': orderBy,
                'filters': filters,
                'search': search,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get a degree by ID
     * @param id Degree ID
     * @returns db_DropdownDegree OK
     * @throws ApiError
     */
    public static getDegree(
        id: number,
    ): CancelablePromise<db_DropdownDegree> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/degrees/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update a degree
     * @param id Degree ID
     * @param body Degree details
     * @returns db_DropdownDegree OK
     * @throws ApiError
     */
    public static updateDegree(
        id: number,
        body: api_updateDropdownItemRequest,
    ): CancelablePromise<db_DropdownDegree> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/degrees/{id}',
            path: {
                'id': id,
            },
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
}
